<template>
  <v-container
    id="about"
    class="pa-0"
    fluid
    tag="section"
  >
    <v-row
      class="ma-0"
      no-gutters
    >
      <v-col
        class="grey lighten-3"
        cols="12"
        md="6"
      >
        <v-img
          height="calc(100vh - 96px - 156px)"
          src="https://astorgolga-assets.s3.eu-west-1.amazonaws.com/photo_cv_olga_astorg.jpg"
        />
      </v-col>

      <v-col
        class="d-block d-md-flex align-center grey lighten-3 pa-6"
        cols="12"
        md="6"
      >
        <v-responsive
          class="mx-auto px-3 px-md-12"
          max-width="750"
        >
          <h1
            class="mb-6"
            :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'"
          >
            Biographie<br>
          </h1>
          <v-card
            class="mx-auto"
          >
            <p>
              Iconographe et peintre russe, je m'appelle Olga Astorg-Zayakina et suis diplômée de l’Académie des Beaux Arts de Saint-Pétersbourg.
            </p>

            <p>
              Formée à l’art monumental (textiles d’intérieur), j'ai notamment réalisé les décors de plusieurs ballets dont « Casse-noisette » et « Le lac des cygnes » pour le théâtre de la Scala de Milan, le Bolchoï à Moscou, ainsi que pour le théâtre Imperial Mikhaïlovsky et le théâtre Mariinsky à Saint-Petersbourg.
            </p>
          </v-card>
          <h1
            class="mb-6"
            :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'"
          >
            Expositions<br>
          </h1>
          <v-list dense>
            <!-- <v-subheader>REPORTS</v-subheader> -->
            <v-list-item-group
              color="primary"
            >
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
              >
                <!-- <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon> -->
                <v-list-item-content>
                  <v-list-item-title v-text="item.date" />
                  <v-list-item-title v-text="item.location" />
                  <v-list-item-title v-text="item.title" />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <div class="signature">
            Olga Astorg
          </div>
        </v-responsive>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'About',

    data: () => ({
      selectedItem: 1,
      items: [
        { date: '2022', location: 'Albi', title: 'Salon du Livre' },
        { date: '2022', location: 'Albi', title: 'Eglise Notre Dame de la Drèche' },
        { date: '2022', location: 'Balma (Haute Garonne)', title: 'Salon des Arts' },
        { date: '2021', location: 'Albi', title: 'Athanor Déco : résidence d’artiste et exposition' },
        { date: '2021', location: 'Albi', title: 'Journées du Patrimoine à l’Ecole Européenne de l’Art et la Matière : exposition d’icônes et peinture sur soie' },
        { date: '2021', location: 'Albi', title: 'Expo - portes ouvertes à l’atelier de sculpture de Corinne Chauvet' },
        { date: '2020', location: 'Albi Galerie Castel’Art', title: 'exposition « Icônes »' },
        { date: '2019', location: 'Lescure (Tarn)', title: 'Eglise Saint Michel exposition d’icônes : « Entre tradition et création »' },
        { date: '2018', location: 'Salies de Béarn (Pyrénées Atlantique)', title: 'concours-exposition' },
        { date: '2017', location: 'Albi', title: 'Exposition « La main et l’outil » à Hôtel Rochegude' },
        { date: '2014', location: 'Albi', title: 'Exposition « Couleur Slave »' },
        { date: '2011', location: 'Albi', title: 'Exposition internationale artistique « Slav’errance »' },
        { date: '2010', location: 'Moscou', title: 'Exposition permanente à la galerie Bykova' },
        { date: '2010', location: 'République de Carélie', title: 'Exposition « Cile et terre de Vodlozero » au musée Korableva' },
        { date: '2009', location: 'Pologne', title: 'Exposition d’Eté artistique international' },
        { date: '2009', location: 'Saint-Petersbourg', title: 'Concours-exposition de dessin de l’Académie des Beaux Arts' },
        { date: '2009', location: 'Moscou', title: 'Exposition sur l’Espagne et sur la France à l’Université des Arts S. Stroganova' },
        { date: '2008', location: 'Saint-Petersbourg', title: 'Exposition sur l’Espagne à l’Académie des Beaux Arts' },
        { date: '2007', location: 'Saint-Petersbourg', title: 'Concours-exposition de projets de Design « Perspective »' },
        { date: '2008', location: 'Consulat d’Allemagne de Saint-Petersbourg', title: 'Exposition sur « l’Allemagne ici et maintenant »' },
      ],
    }),
  }
</script>
<style lang="sass">
  .signature
    font-family: 'Cedarville Cursive', cursive !important
    font-size: 2rem
    font-style: italic
</style>
